import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";

// Main Website Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Languages from "./components/Languages";
import Courses from "./components/Courses";
import About from "./components/About";
import Instructors from "./components/Instructors";
import NewsSection from "./components/NewsSection";
import BookingSystem from "./components/BookingSystem";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Main Website */}
              <Route path="/" element={
                <>
                  <Header />
                  <Hero />
                  <Languages />
                  <Courses />
                  <About />
                  {/*{<Instructors /> */}
                  {/*{ <NewsSection />} */}
                  <Contact />
                  <Footer />
                </>
              } />
              <Route path="/booking" element={
                  <BookingSystem />
              } />
            </Routes>
          </BrowserRouter>
        </div>
      </LanguageProvider>
  );
}

export default App;